module.exports = __webpack_public_path__ + "static/media/cross.2545aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Jerseys/CollectionsList/cross.png
// module id = 1168
// module chunks = 0